import React, { useContext, useEffect, useRef, useState } from 'react'
import 'react-mde/lib/styles/css/react-mde-all.css'
import { each, get, isEmpty } from 'lodash'
import Annotation from './annotation'
import Collections from './collections'
import RelatedContent from './related'
import { getPage } from '../../api/getPage'
import { BookInfo, MenuContext, UserInfo } from '../../contexts/menuContext'
import { useHistory } from 'react-router-dom'

const Footnotes = ({ content }) => {
  const [book, , , setPage, , setForceScroll] = useContext(BookInfo)
  const [, changeMenuStatus, , changeRightSidebar, userClosedMenu] = useContext(MenuContext)
  const cleanContent = useRef(null)
  const history = useHistory();
  useEffect(() => {
    const links = cleanContent.current.querySelectorAll('a[data-content-type="subsection"]')
    if (links.length) {
      each(links, (link) => {
        link.addEventListener('click', (e) => {
          if (get(book, 'id') === get(link, 'dataset.idBook')) {
            setPage(get(link, 'dataset.id'))
            setForceScroll(true)
            let targetUrl = get(e.target, 'url', get(book, 'url'))
            history.push(targetUrl)
            e.preventDefault()
            return false
          }
          return true
        })
        link.addEventListener('mouseenter', (e) => {
          if (get(book, 'id') === get(e.target, 'dataset.idBook')) {
            getPage(get(e.target, 'dataset.id'), book)
          }
        })
      })
    }
    // eslint-disable-next-line
  }, [book])
  return (
    <div className="footnotes-wrapper">
      <div className="footnotes-header">
        <div className="footnotes">
          <h2>Footnotes</h2>
        </div>
        <div
          className="footnotes-close"
          onClick={() => {
            changeRightSidebar(false)
            changeMenuStatus(!userClosedMenu)
          }}
        ><svg xmlns="http://www.w3.org/2000/svg" id="Outlined" viewBox="0 0 32 32" fill="currentColor">
          <title/>
          <g id="Fill">
            <polygon points="28.71 4.71 27.29 3.29 16 14.59 4.71 3.29 3.29 4.71 14.59 16 3.29 27.29 4.71 28.71 16 17.41 27.29 28.71 28.71 27.29 17.41 16 28.71 4.71"/>
          </g>
        </svg>
        </div>

      </div>
      <div className="footnotes-wrapper-inner">
        <div className="footnotes-content bookreader-footnotes" ref={cleanContent} dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  )
}

const RightSidebar = () => {
  const [book, , page] = useContext(BookInfo)
  const [, changeMenuStatus, rightSidebar, changeRightSidebar, userClosedMenu,] = useContext(MenuContext)
  const [content, setContent] = useState({})
  const [user] = useContext(UserInfo)
  useEffect(() => {
    if (!isEmpty(page)) {
      getPage(page, book).then((data) => {
        setContent(data)
      })
    }
  }, [page, book, rightSidebar])
  const changeState = (target) => {
    if (target.dataset.name === rightSidebar) {
      changeRightSidebar(false)
      changeMenuStatus(!userClosedMenu)
    } else {
      changeRightSidebar(target.dataset.name)
      changeMenuStatus(false)
    }
  }
  const logAnnotation = /^-?\d+$/.test(page) && get(user, 'id') && ['chapters', 'index', 'appendices'].includes(get(book, 'page_type', '')) ? 'logged' : 'anonymous'
  const logCollections = ['chapters', 'index', 'appendices'].includes(get(book, 'page_type', '')) ? 'logged' : 'anonymous'
  const logFootnotes = get(content, 'content.footnotes', false) && ['chapters', 'index', 'appendices'].includes(get(book, 'page_type', '')) ? 'logged' : 'anonymous'
  return (
    <div className={`right-sidebar ${rightSidebar && 'open'}`} >
      <div className="right-sidebar--buttons">
        <button
          className={`${logAnnotation}`}
          type="button"
          data-active={`${rightSidebar === 'annotation'}`}
          data-name="annotation"
          onClick={(e) => {
            if (logAnnotation !== 'anonymous') {
              if (get(user, 'id')) {
                changeState(e.target)
              }
            }
          }}
        >
          {get(user, 'annotations', []).includes(page) && <div className="right-sidebar--buttons--identification"/>}
          <svg
            version="1.1"
            viewBox="0 0 24 24"
            xmlSpace="preserve"
            fill="currentColor"
          >
            <g id="icon"><path d="M8.163,12.526l-0.002,0.002c-0.058,0.058-0.093,0.128-0.117,0.201c-0.002,0.008-0.01,0.012-0.012,0.02l-0.991,3.595   c-0.048,0.173,0.001,0.359,0.128,0.486c0.095,0.095,0.223,0.146,0.354,0.146c0.044,0,0.089-0.006,0.133-0.018l3.595-0.991   c0.008-0.002,0.012-0.009,0.02-0.012c0.073-0.024,0.143-0.059,0.201-0.117l0.002-0.002c0,0,0,0,0,0l12.17-12.17   c0.474-0.474,0.474-1.244,0-1.718l-1.593-1.593c-0.474-0.474-1.244-0.474-1.718,0L8.163,12.526   C8.163,12.526,8.163,12.526,8.163,12.526z M21.041,1.063c0.084-0.084,0.22-0.084,0.304,0l1.593,1.593   c0.083,0.084,0.083,0.22,0,0.304l-0.443,0.443l-1.896-1.896L21.041,1.063z M19.891,2.213l1.896,1.896L11.118,14.778l-1.896-1.896   L19.891,2.213z M8.769,13.843l1.389,1.389L8.24,15.76L8.769,13.843z"/>
              <path
                d="M1.818,24h17.364C20.185,24,21,23.185,21,22.182V10.414c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5v11.768   C20,22.633,19.633,23,19.182,23H1.818C1.367,23,1,22.633,1,22.182V4.818C1,4.367,1.367,4,1.818,4h11.768c0.276,0,0.5-0.224,0.5-0.5   S13.862,3,13.586,3H1.818C0.815,3,0,3.815,0,4.818v17.364C0,23.185,0.815,24,1.818,24z"
              />
            </g>
          </svg>
          <span>Annotations</span>
        </button>
        <button
          className={`${logCollections}`}
          type="button"
          data-active={`${rightSidebar === 'collections'}`}
          data-name="collections"
          onClick={(e) => {
            if (logCollections !== 'anonymous') {
              changeState(e.target)
            }
          }}
        >
          <svg
            enableBackground="new 0 0 96 96"
            height="96px"
            id="grid"
            version="1.1"
            viewBox="0 0 96 96"
            width="96px"
            xmlSpace="preserve"
            fill="currentColor"
          >
            <path d="M32,4H16C9.37,4,4,9.37,4,16v16c0,6.63,5.37,12,12,12h16c6.63,0,12-5.37,12-12V16C44,9.37,38.63,4,32,4z M36,32  c0,2.21-1.79,4-4,4H16c-2.21,0-4-1.79-4-4V16c0-2.21,1.79-4,4-4h16c2.21,0,4,1.79,4,4V32z"/><path d="M80,4H64c-6.63,0-12,5.37-12,12v16c0,6.63,5.37,12,12,12h16c6.63,0,12-5.37,12-12V16C92,9.37,86.63,4,80,4z M84,32  c0,2.21-1.79,4-4,4H64c-2.21,0-4-1.79-4-4V16c0-2.21,1.79-4,4-4h16c2.21,0,4,1.79,4,4V32z"/><path d="M80,52H64c-6.63,0-12,5.37-12,12v16c0,6.63,5.37,12,12,12h16c6.63,0,12-5.37,12-12V64C92,57.37,86.63,52,80,52z M84,80  c0,2.21-1.79,4-4,4H64c-2.21,0-4-1.79-4-4V64c0-2.21,1.79-4,4-4h16c2.21,0,4,1.79,4,4V80z"/><path d="M32,52H16C9.37,52,4,57.37,4,64v16c0,6.63,5.37,12,12,12h16c6.63,0,12-5.37,12-12V64C44,57.37,38.63,52,32,52z M36,80  c0,2.21-1.79,4-4,4H16c-2.21,0-4-1.79-4-4V64c0-2.21,1.79-4,4-4h16c2.21,0,4,1.79,4,4V80z"/>
          </svg>
          <span>Collections</span>
        </button>
        <button
          className={`${logFootnotes}`}
          type="button"
          data-active={`${rightSidebar === 'footnotes'}`}
          data-name="footnotes"
          onClick={(e) => {
            if (logFootnotes !== 'anonymous') {
              if (get(content, 'content.footnotes', false)) {
                e.stopPropagation()
                changeState(e.target)
              }
            }
          }}
        >
          <svg id="Capa_1" viewBox="0 0 512 512" fill="currentColor"><path d="m193.322 0-193.322 512h133.103l38.247-109.028h164.18l40.458 109.028h136.012l-199.059-512zm17.329 292.098 41.572-118.286 42.393 118.286z"/></svg>
          <span>Footnotes</span>
        </button>
        <button
          className={`${logAnnotation}`}
          type="button"
          data-active={`${rightSidebar === 'related'}`}
          data-name="related"
          onClick={(e) => {
            if (logAnnotation !== 'anonymous') {
              if (get(user, 'id')) {
                changeState(e.target)
              }
            }
          }}
        >
          <svg id="relatedContentIcon" fill="currentColor" viewBox="0 0 128 128">
            <path d="M105,82a23,23,0,0,0-22.49,18.17L41.74,77.29a23,23,0,0,0,0-26.57L82.51,27.83a23,23,0,1,0-.44-6.63l-44.53,25a23,23,0,1,0,0,35.62l44.53,25A23,23,0,1,0,105,82Zm0-76A17,17,0,1,1,88,23,17,17,0,0,1,105,6ZM11,76A17,17,0,0,1,35,52h0A17,17,0,0,1,11,76Zm94,46a17,17,0,1,1,17-17A17,17,0,0,1,105,122Z"/>
          </svg>
          <span>Related Content</span>
        </button>
      </div>
      <div className={`right-sidebar-overlay ${rightSidebar && 'open'} ${rightSidebar}-style`}>
        {rightSidebar === 'annotation' ? <Annotation/> :
          rightSidebar === 'footnotes' ? <Footnotes content={get(content, 'content.footnotes', 'No footnotes')}/> :
            rightSidebar === 'collections' ? <Collections/> :
              rightSidebar === 'related' ? <RelatedContent/> : rightSidebar}
      </div>
    </div>
  )
}

export default RightSidebar
